import { jsxs as P, jsx as i } from "react/jsx-runtime";
import { Loader as U } from "@systemeio/ui";
import { useVirtualizer as V } from "@tanstack/react-virtual";
import _, { useState as p, useEffect as x } from "react";
import { FileCard as Y } from "../../../components/file-card/index.mjs";
import { FileActionMenuDetailsItem as Z, FileActionMenuDeleteItem as $, FileActionMenuRenameItem as G, FileActionMenuDownloadItem as ee } from "../../../components/file-action-menu-item/index.mjs";
import { isDataFileInterface as te } from "@systemeio/types";
const z = 2, re = 6, ne = z * 2 + re;
function de({
  initialItemWidth: m = 150,
  initialItemHeight: v = 180,
  rowGap: b = 18,
  columnGap: c = 16,
  columnCount: L = 6,
  dataFilesApi: W,
  specialElementInGrid: I,
  onSelect: C,
  onDetails: F,
  onDelete: S,
  onRename: A,
  onDownload: E
}) {
  var D;
  const o = _.useRef(null), d = _.useRef(null), [s, j] = p(L), [l, B] = p(m), [a, H] = p(v), [y, X] = p(), { data: M, fetchNextPage: T, hasNextPage: N, isFetchingNextPage: f, isFetching: q } = W, h = "specialElementInGridId", w = I ? s >= 2 ? [h, h] : [h] : [], R = [...w, ...((D = M == null ? void 0 : M.pages) == null ? void 0 : D.flatMap((t) => t.items)) ?? []], J = R.length;
  x(() => {
    const t = () => {
      if (o.current) {
        const n = o.current.offsetWidth - ne, e = Math.floor(n / (m + c));
        j(e || 1);
        const u = (n - c * (e - 1)) / e;
        B(u), H(u / m * v);
      }
    };
    t();
    const r = new ResizeObserver(t);
    return o.current && r.observe(o.current), () => r.disconnect();
  }, [m, v, c]);
  const k = V({
    count: Math.ceil(J / s),
    gap: b,
    getScrollElement: () => o.current,
    estimateSize: () => a
  }), O = V({
    count: s,
    gap: c,
    getScrollElement: () => o.current,
    estimateSize: () => l,
    horizontal: !0
  });
  return x(() => {
    if (!d.current || !N || f) return;
    const t = new IntersectionObserver(
      (r) => {
        var n;
        (n = r[0]) != null && n.isIntersecting && T();
      },
      { root: o.current, threshold: 0.1 }
    );
    return t.observe(d.current), () => {
      d.current && t.unobserve(d.current);
    };
  }, [T, N, f]), x(() => {
    const t = R.filter(te).find((r) => r.id === y);
    C == null || C(t);
  }, [y]), /* @__PURE__ */ P(
    "div",
    {
      ref: o,
      className: "customScroll relative h-[400px] w-full overflow-auto",
      style: { paddingTop: z, paddingLeft: z },
      children: [
        /* @__PURE__ */ P(
          "div",
          {
            style: {
              height: k.getTotalSize(),
              width: O.getTotalSize()
            },
            className: "relative",
            children: [
              q && !f ? Array.from({ length: 10 }).map((t, r) => /* @__PURE__ */ i(
                "div",
                {
                  className: "bg-background-tertiary absolute animate-pulse rounded-md",
                  style: {
                    top: Math.floor(r / s) * (a + b),
                    left: r % s * (l + c),
                    height: a,
                    width: l
                  }
                },
                r
              )) : k.getVirtualItems().map(
                (t) => O.getVirtualItems().map((r) => {
                  const n = t.index * s + r.index, e = R[n];
                  if (!e) return null;
                  let u = Math.floor(n / s) * (a + b);
                  const K = n % s * (l + c);
                  let g = 0;
                  switch (s) {
                    case 1:
                      g = 180;
                      break;
                    case 2:
                      g = 80;
                      break;
                  }
                  return I && (u = u - g), h === e ? n === 0 ? /* @__PURE__ */ i(
                    "div",
                    {
                      style: {
                        top: 0,
                        left: 0,
                        height: a - g,
                        width: l * w.length + c * (w.length - 1)
                      },
                      children: I
                    },
                    e + n
                  ) : null : /* @__PURE__ */ i(
                    Y,
                    {
                      src: e.thumbnail ?? e.path ?? void 0,
                      alt: e.name,
                      name: e.name,
                      imageWidth: l,
                      imageHeight: l * 0.869,
                      secondaryText: e.type,
                      fileType: e.type,
                      style: {
                        top: u,
                        left: K,
                        height: a,
                        width: l
                      },
                      selected: y === e.id,
                      onSelect: (Q) => {
                        X(Q ? e.id : void 0);
                      },
                      className: "absolute",
                      actionMenu: {
                        menuItems: [
                          F ? /* @__PURE__ */ i(
                            Z,
                            {
                              onClick: () => F(e)
                            },
                            "details"
                          ) : void 0,
                          S ? /* @__PURE__ */ i(
                            $,
                            {
                              onClick: () => S(e)
                            },
                            "delete"
                          ) : void 0,
                          A ? /* @__PURE__ */ i(
                            G,
                            {
                              onClick: () => A(e)
                            },
                            "rename"
                          ) : void 0,
                          E ? /* @__PURE__ */ i(
                            ee,
                            {
                              onClick: () => E(e)
                            },
                            "download"
                          ) : void 0
                        ].filter(Boolean)
                      }
                    },
                    e.id
                  );
                })
              ),
              N && /* @__PURE__ */ i("div", { ref: d, className: "absolute bottom-0" })
            ]
          }
        ),
        /* @__PURE__ */ i("div", { className: "flex h-11 w-full items-center justify-center pt-4", children: f && /* @__PURE__ */ i(U, {}) })
      ]
    }
  );
}
export {
  de as FileGrid
};
